import React from 'react';
import { useOutletContext, useParams } from 'react-router-dom';

import { EditButton } from '../../../../components/StyledButton';
import { pageKeywords, pagePaths } from '../../../../constants/Page';
import { useEngeneNavigate } from '../../../../hooks/navigate';
import Detail from './Detail';
import { ExpenseDetailContext, ExpenseDetailParams } from './ExpenseDetail';

/**
 * 経費詳細画面 閲覧モード
 * @returns
 */
const ExpenseDetailView: React.FunctionComponent = () => {
  const navigate = useEngeneNavigate();
  const params = useParams<ExpenseDetailParams>();

  const { refetch } = useOutletContext<ExpenseDetailContext>();

  React.useState(() => refetch());

  return (
    <Detail mode="view">
      <EditButton
        onClick={() =>
          navigate(
            `${pagePaths.EXPENSE_DETAIL}/${params.expenseId}/${pageKeywords.mode.EDIT}`
          )
        }
      />
    </Detail>
  );
};

export default ExpenseDetailView;
